export const SEND_ALERT = "@@alerts/SEND_ALERT";
export const CLOSE_ALERT = "@@alerts/CLOSE_ALERT";
export const ENABLE_LOADING = "@@alerts/ENABLE_LOADING";
export const DISABLE_LOADING = "@@alerts/DISABLE_LOADING";
export const SET_PERCENTAGE = "@@alerts/SET_PERCENTAGE";

export function sendAlert(title, content) {
  return { type: SEND_ALERT, payload: { title, content } };
}
export function closeAlert() {
  return { type: CLOSE_ALERT, payload: {} };
}
export function enableLoading() {
  return { type: ENABLE_LOADING, payload: {} };
}
export function disableLoading() {
  return { type: DISABLE_LOADING, payload: {} };
}
export function setPercentage(percentage) {
  return { type: SET_PERCENTAGE, payload: { percentage } };
}
